import Pareto from './pareto';

export default Pareto;
